export const LATIHANS_GET = 'LATIHANS_GET';
export const LATIHAN_ADD = 'LATIHAN_ADD';
export const LATIHAN_GET = 'LATIHAN_GET';
export const LATIHAN_EDIT = 'LATIHAN_EDIT';
export const LATIHAN_UPLOADFILE = 'LATIHAN_UPLOADFILE';
export const LATIHAN_DELETE = 'LATIHAN_DELETE';
export const LATIHAN_RESET_SEARCH = 'LATIHAN_RESET_SEARCH';
